// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import SvgIcon from 'vue-svgicon'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import VueClipboard from 'vue-clipboard2'
import env from './tools/env'
import Amplify from 'aws-amplify'

if (localStorage.getItem('country') && localStorage.getItem('localeRegion')) {
  Vue.prototype.$localeRegion = localStorage.getItem('localeRegion')
  Vue.prototype.$country = localStorage.getItem('country')
} else {
  let locale
  locale = navigator.language || navigator.languages[0]
  if (locale.includes('fr')) {
    localStorage.setItem('localeRegion', 'fr')
    localStorage.setItem('country', 'FR')
    Vue.prototype.$localeRegion = 'fr'
    Vue.prototype.$country = 'FR'
  } else {
    localStorage.setItem('localeRegion', 'en')
    localStorage.setItem('country', 'US')
    Vue.prototype.$localeRegion = 'en'
    Vue.prototype.$country = 'US'
  }
}

if (Vue.prototype.$country === 'FR') {
  Vue.prototype.$locale = 'fr'
} else {
  Vue.prototype.$locale = 'en'
}

const amplifyConfig = () => {
  let s3 = null
  if (Vue.prototype.$country === 'US') {
    s3 = {
      bucket: {
        prod: 'rematch-us-data',
        preprod: 'rematch-us-data-preprod',
        dev: 'rematch-us-data-preprod'
      },
      region: 'us-east-2'
    }
  } else {
    s3 = {
      bucket: {
        prod: 'rematch-data',
        preprod: 'rematch-data-preprod',
        dev: 'rematch-data-dev'
      },
      region: 'eu-west-3'
    }
  }

  if (env === 'prod') {
    return {
      Auth: {
        identityPoolId: 'eu-west-2:ab2ab71f-878e-4593-9ab7-c6192c79b871',
        region: 'eu-west-2',
        identityPoolRegion: 'eu-west-2',
        userPoolId: 'eu-west-2_WaEDvxACl',
        userPoolWebClientId: '4p052gf20d23kndlfeivgn4g3l',
        authenticationFlowType: 'USER_PASSWORD_AUTH'
      },
      Storage: {
        AWSS3: {
          bucket: s3.bucket['prod'],
          region: s3.region['prod'],
          customPrefix: {
            public: ''
          }
        }
      }
    }
  } else if (env === 'preprod') {
    return {
      Auth: {
        identityPoolId: 'eu-west-2:b495f7a0-3907-4546-9542-cec49485815c',
        region: 'eu-west-2',
        identityPoolRegion: 'eu-west-2',
        userPoolId: 'eu-west-2_7bJB1pdE6',
        userPoolWebClientId: '3uc3rl4lo25qpfsg5a2vvk1oa3',
        authenticationFlowType: 'USER_PASSWORD_AUTH'
      },
      Storage: {
        AWSS3: {
          bucket: s3.bucket['preprod'],
          region: s3.region['preprod'],
          customPrefix: {
            public: ''
          }
        }
      }
    }
  } else if (env === 'dev') {
    return {
      Auth: {
        identityPoolId: 'eu-west-2:f36215bd-d084-4161-b161-12396854b73c',
        region: 'eu-west-2',
        identityPoolRegion: 'eu-west-2',
        userPoolId: 'eu-west-2_KQ7ql3h5F',
        userPoolWebClientId: '3bgaphpqousdpu2kt818cpq1a0'
      },
      Storage: {
        AWSS3: {
          bucket: s3.bucket['dev'],
          region: s3.region['dev'],
          customPrefix: {
            public: ''
          }
        }
      }
    }
  } else {
    return {
      Auth: {
        identityPoolId: 'eu-west-2:ab2ab71f-878e-4593-9ab7-c6192c79b871',
        region: 'eu-west-2',
        identityPoolRegion: 'eu-west-2',
        userPoolId: 'eu-west-2_EeGazSTuO',
        userPoolWebClientId: '5atpltqgdf4j4kmfg8il3i348j'
      },
      Storage: {
        AWSS3: {
          bucket: s3.bucket['prod'],
          region: s3.region['prod'],
          customPrefix: {
            public: ''
          }
        }
      }
    }
  }
}

Amplify.configure(amplifyConfig())
// Amplify.Logger.LOG_LEVEL = 'DEBUG'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(SvgIcon)
Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    primary: '#000099'
  }
})
Vue.use(VueClipboard)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js